import getApplicationConfig from 'src/constants/environment'

const config = getApplicationConfig()
export default config
